import YoutubeConnectCard from "./connectCard";
import ConnectedYoutubeAccounts from "./youtubeAccounts";

function YoutubeChannels() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fill, minmax(280px, 280px))",
        gap: "20px",
        alignItems: "start",
      }}
    >
      <YoutubeConnectCard />
      <ConnectedYoutubeAccounts />
    </div>
  );
}

export default YoutubeChannels;